<template>
    <section name="address-card" class="checkups__address-card" @click="goTo()">
        <div>
            <span><b>{{ objType.type === 'bid' ? 'Адрес' : 'Помещение' }}</b></span>
        </div>
        <section>
            <div>
                <span>{{ attributes.citytype }} {{ attributes.city }}</span>
            </div>
            <div>
                <span>{{ attributes.streettype }} {{ attributes.street }} <nobr>№ {{ attributes.number }}</nobr></span>
            </div>
        </section>
        <section v-if="objType.type === 'pid'">
            <div v-if="attributes.levelNumber">
                <span>этаж № {{ attributes.levelNumber }}</span>
            </div>
            <div v-if="attributes.roomNumber">
                <span>помещение № {{ attributes.roomNumber }}</span>
            </div>
        </section>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'CheckupsAddressCard',

    props: {
        objType: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            attributes: {}
        }
    },
    computed: {
        type() {
            return this.objType
        }
    },
    methods: {
        ...mapActions({
            getBuilding: 'addressesGetBuilding',
            getShelter: 'addressesGetShelter',
        }),

        getAddress(data, type) {
            if (type === 'bid') {
                this.getBuilding(data).then(result => {
                    this.attributes = result.data.data.attributes
                })
            } 
            else if (type === 'pid') {
                this.getShelter(data).then(result => {
                    const property = result.data.data.attributes
                    const propId = result.data.data.id
                    this.getBuilding(property.bid).then(result => {
                        this.attributes = result.data.data.attributes
                        this.attributes.roomNumber = property.number
                        this.attributes.levelNumber = property.level
                        this.attributes.propertyId = propId
                    })
                    console.log(result)
                })
            }
        },
        goTo() {
            if (this.objType.type === 'bid') {
                window.open(`/admin/address/${this.objType.id}/schedule`)
            }
            if (this.objType.type === 'pid') {
                window.open(`/admin/shelter/${this.objType.id}/schedule`)
            }
        }
    },
    watch: {
        type: {
            handler(val) {
                this.getAddress(val.id, val.type)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>